function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{opacity:0.4295;enable-background:new    ;}\n\t.st1{opacity:0.1255;fill:#0D6D9E;enable-background:new    ;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{opacity:0.5;fill-rule:evenodd;clip-rule:evenodd;fill:#D6DCE4;}\n\t.st4{fill:none;stroke:#D6DCE4;stroke-width:8;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("rect", {
  className: "st1",
  width: 567.1,
  height: 302.6
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 283.5,
  cy: 151.3,
  r: 100
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "228.7,174.8 283.3,127.9 338.5,174.8 283.6,221.6  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M286.3,173.6c-1.6,1.4-4,1.5-5.3,0.3l-51.4-43.8c-1.4-1.2-1.2-3.2,0.3-4.5l50.9-43.4c1.6-1.4,4-1.5,5.3-0.3 l51.4,43.8c1.4,1.2,1.2,3.2-0.3,4.5L286.3,173.6z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M286.3,220.5c-1.6,1.4-4,1.5-5.3,0.3l-51.4-43.8c-1.4-1.2-1.2-3.2,0.3-4.5l50.9-43.4c1.6-1.4,4-1.5,5.3-0.3 l51.4,43.8c1.4,1.2,1.2,3.2-0.3,4.5L286.3,220.5z"
})), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 228.6,
  y1: 127.8,
  x2: 228.6,
  y2: 174.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 283.5,
  y1: 174.8,
  x2: 283.5,
  y2: 221.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 338.5,
  y1: 127.8,
  x2: 338.5,
  y2: 174.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 283.5,
  y1: 81,
  x2: 283.5,
  y2: 127.8
})));

function Svg3DAssetTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 567.1 302.6",
    style: {
      enableBackground: "new 0 0 567.1 302.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DAssetTypeIcon);
export default __webpack_public_path__ + "static/media/3d-asset-type-icon.68c5dfa4.svg";
export { ForwardRef as ReactComponent };